// components/AdminDashboard.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Megaphone, Package, Image, Info, ArrowRight, Quote } from 'lucide-react';

const AdminDashboard = () => {
    const modules = [
        {
            path: '/admin/about',
            name: 'Gestor de Nosotros',
            icon: <Info size={40} />,
            description: 'Administra el contenido de la sección Nosotros',
            color: 'from-purple-500 to-pink-500'
        },
        {
            path: '/admin/ads',
            name: 'Gestor de Anuncios',
            icon: <Megaphone size={40} />,
            description: 'Administra los anuncios del carrusel',
            color: 'from-purple-500 to-pink-500'
        },
        {
            path: '/admin/products',
            name: 'Gestor de Productos',
            icon: <Package size={40} />,
            description: 'Administra los productos del catálogo',
            color: 'from-blue-500 to-cyan-500'
        },
        {
            path: '/admin/gallery',
            name: 'Gestor de Galería',
            icon: <Image size={40} />,
            description: 'Administra las imágenes de la galería',
            color: 'from-green-500 to-emerald-500'
        },
        {
            path: '/admin/quotes',
            name: 'Cotizaciones',
            icon: <Quote size={40} />,
            description: 'Ver imágenes de cotizaciones recibidas',
            color: 'from-orange-500 to-red-500'
        },
    ];

    return (
        <div>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="mb-8"
            >
                <h2 className="text-3xl font-bold text-white mb-2">
                    Bienvenido al Panel de Administración
                </h2>
                <p className="text-gray-400">
                    Selecciona un módulo para comenzar a gestionar
                </p>
            </motion.div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {modules.map((module, index) => (
                    <motion.div
                        key={module.path}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.1 }}
                    >
                        <Link to={module.path}>
                            <div className={`bg-gradient-to-br ${module.color} min-h-60 p-6 rounded-2xl shadow-xl hover:shadow-2xl transform hover:-translate-y-1 flex flex-col items-center justify-center transition-all duration-300`}>
                                <div className="bg-white/20 w-16 h-16 rounded-xl flex items-center justify-center mb-5">
                                    <div className="text-white">
                                        {module.icon}
                                    </div>
                                </div>

                                <h3 className="text-xl font-bold text-white mb-2">
                                    {module.name}
                                </h3>

                                <p className="text-white/80 mb-4">
                                    {module.description}
                                </p>
                            </div>
                        </Link>
                    </motion.div>
                ))}
            </div>

            {/* Quick stats or info */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.4 }}
                className="mt-8 p-6 bg-gray-800 rounded-2xl"
            >
                <h3 className="text-lg font-semibold text-white mb-4">
                    Información del Sistema
                </h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div>
                        <p className="text-sm text-gray-400">Versión</p>
                        <p className="text-xl font-bold text-white">1.0.0</p>
                    </div>
                    <div>
                        <p className="text-sm text-gray-400">Entorno</p>
                        <p className="text-xl font-bold text-white">
                            {process.env.NODE_ENV === 'production' ? 'Producción' : 'Desarrollo'}
                        </p>
                    </div>
                    <div>
                        <p className="text-sm text-gray-400">Último acceso</p>
                        <p className="text-xl font-bold text-white">
                            {new Date().toLocaleDateString()}
                        </p>
                    </div>
                    <div>
                        <p className="text-sm text-gray-400">Módulos activos</p>
                        <p className="text-xl font-bold text-white">5</p>
                    </div>
                </div>
            </motion.div>
        </div>
    );
};

export default AdminDashboard;